import type { ReactNode } from 'react'
import { Link } from 'react-router'
import { buttonStyles } from '@/components/ui/buttonStyles'

interface NotFoundContentProps {
  title?: string
  message?: string
  children?: ReactNode
}

export function NotFoundContent({
  title = 'Page not found',
  message = 'This level doesn’t exist — or it was never unlocked.',
  children,
}: NotFoundContentProps) {
  return (
    <div className="container-page grid min-h-[60vh] place-items-center py-16 text-center">
      {children}
      <div>
        <p className="font-display text-[7rem] leading-none font-extrabold tracking-tighter text-volt sm:text-[9rem]">404</p>
        <h1 className="mt-2 text-3xl font-bold sm:text-4xl">{title}</h1>
        <p className="mx-auto mt-3 max-w-md text-fg-muted">{message}</p>
        <Link to="/" className={`${buttonStyles()} mt-8`}>
          Back to games
        </Link>
      </div>
    </div>
  )
}

export default function NotFoundPage() {
  return (
    <NotFoundContent>
      <title>Page not found · Zarcade</title>
      <meta name="robots" content="noindex" />
    </NotFoundContent>
  )
}
